import { EventsLP } from "./EventsLP";
import { Configuration } from "./Configuration";
import { GeneratedCode } from "./GeneratedCode";

export const Widget = { EventsLP, Configuration, GeneratedCode };
